import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./Components/Header.jsx";
import BaseRoute from "./BaseRoute/BaseRoute.jsx";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";
export default function App() {
  return (
    <>
      <BrowserRouter>
        <HelmetProvider>
          <Routes>
            <Route path="/*" element={<BaseRoute />} />
          </Routes>
        </HelmetProvider>
        <ToastContainer
          position="bottom-center"
          autoClose={1000}
          hideProgressBar={true}
          newestOnTop={false}
          // className={"custom-toaster"}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
          toastClassName="custom-toast"
        />
      </BrowserRouter>
    </>
  );
}
